package com.devi3east.bashbuddy.features.common.data.database

import com.devi3east.bashbuddy.BashBuddyLocalDatabase
import com.devi3east.bashbuddy.Recipe
import com.devi3east.bashbuddy.dbFactory.DatabaseFactory
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock

class DbHelper(
    private val driverFactory: DatabaseFactory
) {

    private var db: BashBuddyLocalDatabase? = null
    private val mutex = Mutex()

    suspend fun <Result : Any?> withDatabase(block: suspend (BashBuddyLocalDatabase) -> Result) =
        mutex.withLock {
            if (db == null) {
                db = createDb(driverFactory)
            }

            return@withLock block(db!!)
        }

    private suspend fun createDb(driverFactory: DatabaseFactory): BashBuddyLocalDatabase {
        return BashBuddyLocalDatabase(
            driver = driverFactory.createDriver(),
            RecipeAdapter = Recipe.Adapter(
                ingredientsAdapter = listOfStringsAdapter,
                instructionsAdapter = listOfStringsAdapter
            )
        )
    }
}